import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";
import { Globe, RefreshCw, Shield, CheckCircle } from "lucide-react";
import { useState } from "react";

const DomainSettings = () => {
  const { toast } = useToast();
  const [isSSLVerifying, setIsSSLVerifying] = useState(false);

  const handleVerifyDomain = () => {
    toast({
      title: "Domain Verification",
      description: "Starting domain verification process...",
    });
  };

  const handleSSLSetup = async () => {
    setIsSSLVerifying(true);
    try {
      toast({
        title: "SSL Setup",
        description: "Initiating SSL certificate provisioning...",
      });
      
      // Simulate SSL setup process
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      toast({
        title: "SSL Certificate",
        description: "SSL certificate has been successfully installed",
        variant: "default", // Changed from "success" to "default"
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to setup SSL certificate. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsSSLVerifying(false);
    }
  };

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Globe className="h-5 w-5" />
            <h3 className="text-lg font-medium">Domain Configuration</h3>
          </div>
          
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Custom Domain</Label>
              <div className="flex space-x-2">
                <Input placeholder="Enter your domain (e.g., example.com)" />
                <Button variant="outline" onClick={handleVerifyDomain}>
                  <RefreshCw className="h-4 w-4 mr-2" />
                  Verify
                </Button>
              </div>
            </div>

            <div className="space-y-2">
              <Label>SSL Certificate</Label>
              <Card className="p-4 bg-muted">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Shield className="h-4 w-4 text-green-500" />
                    <span>HTTPS Protection</span>
                  </div>
                  <Button 
                    variant="outline"
                    onClick={handleSSLSetup}
                    disabled={isSSLVerifying}
                  >
                    {isSSLVerifying ? (
                      <>
                        <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                        Verifying...
                      </>
                    ) : (
                      <>
                        <CheckCircle className="h-4 w-4 mr-2" />
                        Setup SSL
                      </>
                    )}
                  </Button>
                </div>
              </Card>
            </div>

            <div className="space-y-2">
              <Label>DNS Records</Label>
              <Card className="p-4 bg-muted">
                <pre className="text-sm">
                  {`CNAME  www  your-app.example.com
A      @    192.0.2.1`}
                </pre>
              </Card>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default DomainSettings;